import { FlexProps } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { ConfettiFlagEmptyState } from "../../../components/ConfettiFlagEmptyState/ConfettiFlagEmptyState";

export const PreSwipeEmptyState = (props: FlexProps) => {
  const navigate = useNavigate();
  return (
    <ConfettiFlagEmptyState
      headline="That's Everyone! Your Thumbs Need a Break."
      body="No more profiles to spark on. Come meet them in person — it's way more fun anyway."
      cta={{ label: "View Upcoming Events", onClick: () => navigate("/events") }}
      {...props}
    />
  );
};
